<template>
  <div style="height: 100%; width: 100%;">
    <v-img
        class="itemImag"
        style="height: 100%; width: 100%; cursor:pointer; background-size: contain !important;"
        :src="url"
        @mouseover="mouseOver"
        @mouseout="onmouseout"
    >
      <div class="details" v-show="active">
        <div class="detailsContent" style="color: black;font-weight: bold;font-size: 20px">
          {{ name }}
        </div>
        <div class="detailsContent ">
          {{ details }}
        </div>
        <div class="price detailsContent">
          {{ price }} $
        </div>
      </div>

    </v-img>

  </div>
</template>

<script>
export default {
  props: ['name','url', 'details', 'price'],
  name: "shopCard",
  data() {
    return {
      active: false,
      windowWidth: window.innerWidth
    }
  },
  methods: {
    mouseOver: function () {
      this.active = true;
    },
    onmouseout: function () {
      this.active = false;
    }
  }
}
</script>

<style scoped>
.details {
  width: 80%;
  margin-top: 35%;
  background-color: #8c9195a3;
}

.detailsContent {
  margin: 0 10px 0 10px;
  text-transform: capitalize;
}
.price{
  color:black;font-size:1.4rem;font-weight:bold;text-align: end; padding-bottom: 5px
}
::v-deep .itemImag .v-image__image--cover{

  background-position: left !important;
}
</style>
